import useKeyPress from '@ally/use-key-press';
import { useClickAway } from '@ally/use-click-away';
import { focusOnInput, containsFocus } from '../utils';
export var useInteractionHandler = function (_a) {
    var showOptions = _a.showOptions, showLoading = _a.showLoading, setShowOptions = _a.setShowOptions, setShowLoading = _a.setShowLoading, inputWrapperRef = _a.inputWrapperRef;
    useClickAway(inputWrapperRef, function () {
        if (showOptions)
            setShowOptions(false);
    });
    useKeyPress(['Escape'], function () {
        if (showOptions) {
            setShowOptions(false);
            focusOnInput(inputWrapperRef);
        }
        if (showLoading) {
            setShowLoading(false);
            focusOnInput(inputWrapperRef);
        }
    });
    useKeyPress(['Enter', 'ArrowDown', 'ArrowUp'], function () {
        if (!showOptions && containsFocus(inputWrapperRef)) {
            setShowOptions(true);
        }
    });
    useKeyPress(['Tab'], function () {
        // check focus one render cycle after the tab press is detected
        setTimeout(function () {
            if (showOptions && !containsFocus(inputWrapperRef)) {
                setShowOptions(false);
            }
        }, 0);
    });
};
//# sourceMappingURL=useInteractionHandler.js.map